<template>
  <v-dialog
    persistent
    v-model="open"
   fullscreen
  >
    <v-card class="fill-height" color="white">
        <v-card-title>
            <div style="flex: 1;  min-width: 70%; /* or some value */">
            <h5 style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <span v-text="title"/>
            </h5>
            </div>
            <v-spacer/>
            <v-btn :href="url" target="_blank" link icon @click="open = false">
                <v-icon small>fa-download</v-icon>
            </v-btn>
            <v-divider vertical />
            <v-btn @click="close" icon>
                <v-icon>fa-times</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text style="height: calc(100% - 65px)">
            <object  :data="url" style="width: 100%; height: 100%" type="application/pdf">
            </object>
        </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import axios from "axios";

  @Component
  export default class PdfViewerDialog extends Vue {
    private url: string = '';
    private open:boolean = false;
    private title:string = '';

    public async show(url:string, title:string):Promise<void> {

        this.title = title;
        const response = await axios.get(url, {responseType: 'blob'});
        const blob = new Blob([response.data], {type: 'application/pdf'})
        //const link = document.createElement('a');
        this.url = URL.createObjectURL(blob);
        this.open = true;
    }

    private close() : void {
        try{
            URL.revokeObjectURL(this.url);
        }catch (e) {
            //console.log(e);
        }

        this.open = false;
    }
  }
</script>

<style>

</style>
